import { SelectOptions } from '@etoh/database/core';

export type agreementRole =
  | 'buyer'
  | 'seller'
  | 'thirdParty'
  | 'all'
  | 'withoutSignatures';

export const agreementRoles: { type: agreementRole; name: string }[] = [
  {
    name: 'Buyer',
    type: 'buyer',
  },
  {
    name: 'Seller',
    type: 'seller',
  },
  {
    name: 'Third Party',
    type: 'thirdParty',
  },
];

export const agreementRolesOptions: SelectOptions[] = agreementRoles.map(
  ({ type, name }) => ({
    value: type,
    label: name,
  })
);
